import { Injectable } from "@angular/core";
import { ICON_ENUM } from "../../components/icon/model/icon.enum";
import { IconModel } from "../../components/icon/model/icon.model";
import { Color } from "../../model/shared.model";


@Injectable({
  providedIn: "root",
})
export class IconUtilityService {
  constructor() { }

  getMatEditIcon(): IconModel {
    return {
      iconName: "edit",
      color: "primary",
      isMatIcon: true,
      iconClass: "action-icon",
    };
  }

  getMatInfoIcon(): IconModel {
    return {
      iconName: "info",
      color: "primary",
      isMatIcon: true,
      iconClass: "action-icon",
    };
  }

  getMatAcceptIcon(): IconModel {
    return {
      iconName: ICON_ENUM.DONE,
      color: "primary",
      isMatIcon: true,
      iconClass: "approve",
    };
  }

  getMatAcceptDectivatedIcon(): IconModel {
    return {
      iconName: ICON_ENUM.DONE,
      color: "primary",
      isMatIcon: true,
      iconClass: "deactivated",
    };
  }

  getMatDiscardIcon(): IconModel {
    return {
      iconName: ICON_ENUM.CANCEL,
      color: "#cc0000",
      isMatIcon: true,
      iconClass: "cancel",
    };
  }

  getMatDiscardIconMaintenancePlanPt(): IconModel {
    return {
      iconName: ICON_ENUM.CANCEL,
      color: "#cc0000",
      isMatIcon: true,
      iconClass: "cancel-maintenance-plan-pt",
    };
  }

  getMatArrowIcon(): IconModel {
    return {
      iconName: "navigate_next",
      color: "primary",
      isMatIcon: true,
      iconClass: "action-icon",
    };
  }

  getMatSearchIcon(): IconModel {
    return {
      iconName: "search",
      color: "primary",
      isMatIcon: true,
      iconClass: "action-icon",
    };
  }

  getMatRefreshIcon(): IconModel {
    return {
      iconName: ICON_ENUM.REFRESH,
      color: Color.BLUE_2,
      isMatIcon: true,
      iconClass: "refresh",
    };
  }
}
